'use strict';

const Analytics = require('./analytics');

class Refund extends Analytics {
    init (globalContainer, helperContainer) {
        this.logName = 'Refund';
        super.init(globalContainer, helperContainer);
        this.prepareObservers();
        this.itemSkus = [];
    }

    prepareObservers () {
        this.prepareReturnProductsFlowObservers();
        this.prepareRefundConfirmationObserver();
    }

    prepareReturnProductsFlowObservers () {
        var _self = this;

        $('body').on('click', '#productsButton', function (e) {
            _self.itemSkus = [];

            $('.reason-form').each((i, form) => {
                let motivationSelected = $(form).find('#reason option:selected');
                if ($(motivationSelected).val() !== '-1' && motivationSelected.val() !== undefined) {
                    let sku = _self.helper.getFormatSku($(motivationSelected).closest('select#reason').data('product-sku'));
                    _self.itemSkus.push(sku);
                    _self.quickImpressionSender.pushRefundOptionMotivationSelect(_self.helper.formatString($(motivationSelected).data('reason')), sku);
                }
            });
        });

        $('body').on('click', '#methodButtonDiv #methodButton', function (e) {
            const shippingMethodOptions = {
                'storeReturnDiv': 'shop',
                'homeReturnDiv': 'home',
                'pickupPointDiv': 'pickup_point'
            };

            let shippingMethodSelected = $('.card-method.js-selected-method').attr('id');
            if (shippingMethodSelected === 'storeReturnDiv') {
                // confirmation through fake ty page - user returning prods into a store
                let transactionID = '';
                let url = new URL(location.href);
                let transactionIDExists = url.searchParams.has('orderID');
                if (transactionIDExists) {
                    transactionID = url.searchParams.get('orderID');
                }
                _self.quickImpressionSender.pushRefundOptionConfirmation(_self.itemSkus.join('-'), shippingMethodOptions[shippingMethodSelected], '0', transactionID);
                _self.itemSkus = [];
            } else {
                // normal refund flow - procceding with payment select
                _self.quickImpressionSender.pushRefundOptionShippingMethod(shippingMethodOptions[shippingMethodSelected], _self.itemSkus.join('-'));
            }
        });

        $('body').on('click', '#confirmButtonDiv #confirmButton', function (e) {
            const refundMethod = $('input[name="method-refund"]:checked').attr('id') === 'digital-wallet-method' ?
                'my_wallet' :
                $('input[name="method-refund"]:checked').attr('id') === 'reso-card-method';
            _self.quickImpressionSender.pushRefundOptionPaymentMethod(
                refundMethod,
                _self.itemSkus.join('-')
            );
        });
    }

    prepareRefundConfirmationObserver () {
        var _self = this;

        $('body').on('refund:confirmation', function (e, data) {
            if (data.status === 1) {
                const refundMethod = data.refundMethod === 'RE_DIGITAL_WALLET' ? 'my_wallet' : (data.refundMethod === 'RE_RETURN.CARD' ? '1' : '0');
                _self.quickImpressionSender.pushRefundOptionConfirmation(
                    _self.itemSkus.join('-'),
                    data.returnMethod !== 'home' ? 'pickup_point' : data.returnMethod,
                    refundMethod,
                    data.returnId
                );
            }
            _self.itemSkus = [];
        });
    }
}

const obj = new Refund();
module.exports = obj;
